/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TimeLineGroupInfoRequest } from "../models/TimeLineGroupInfoRequest";
import type { TimeLineGroupInfoResponseApiRespoonse } from "../models/TimeLineGroupInfoResponseApiRespoonse";
import type { TimeLineListArticleRequest } from "../models/TimeLineListArticleRequest";
import type { TimeLineListArticleResponseApiRespoonse } from "../models/TimeLineListArticleResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class TimeLineService {
  /**
   * get articles
   * @param requestBody
   * @returns TimeLineGroupInfoResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberGroupInfoTimeline(
    requestBody: TimeLineGroupInfoRequest
  ): CancelablePromise<TimeLineGroupInfoResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/group_info/timeline",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * get articles
   * @param requestBody
   * @returns TimeLineListArticleResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static userTimeline(
    requestBody: TimeLineListArticleRequest
  ): CancelablePromise<TimeLineListArticleResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/timeline",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
